import Vue from 'vue'
import Vuex from 'vuex'
import appModule from './app'
import authModule from './auth'
import userModule from './user'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		app: appModule,
		auth: authModule,
		user: userModule
	}
});
